import BaseModel from "../base/baseModel";

export default class RacaAnimalModel extends BaseModel {
    id = 0;
    descricao: string = null;
    especieAnimalId = 0;
    especieAnimalDescricao: string = null;
    franquiaId?: number = null;
}
